module.exports = __webpack_public_path__ + "img/pr-thu.19cdd4f9.png";